export default __webpack_public_path__ + "static/devops-consulting-services-peerbits-08114508f305814e7dfc10e0c3c4946e.png";